import { render, staticRenderFns } from "./SSubmenu.vue?vue&type=template&id=41ecb976&scoped=true&"
import script from "./SSubmenu.vue?vue&type=script&lang=ts&"
export * from "./SSubmenu.vue?vue&type=script&lang=ts&"
import style0 from "./SSubmenu.vue?vue&type=style&index=0&id=41ecb976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ecb976",
  null
  
)

export default component.exports